<template>
  <div class="lanSet">
    <b-button variant="primary" class="update_btn" @click="remark" v-if="roleType == 1">
      {{ $t("publicManage.lanset.text1") }}</b-button>
    <b-card>
      <b-tabs class="tab-header" v-model="tabIndex" pills card>
        <!-- 后台系统 -->
        <b-tab :title="$t('lanV4.backEnd')" @click="handleChangeTab(6)">
          <languageSetAdmin />
        </b-tab>
        <!-- 服务端 -->
        <b-tab :title="$t('publicManage.lanset.server')" @click="handleChangeTab(5)">
          <serverLanguageService />
        </b-tab>
      </b-tabs>
      <b-modal v-model="statusFlag" :title="$t('publicManage.lanset.tip')" id="small-modal" size="md"
        no-close-on-backdrop>
        <section>
          <p class="modal-titles">
            {{
      $t("publicManage.lanset.statusTitle", {
        lang: activeRow.langName,
      })
    }}
          </p>
          <p v-if="tabIndex !== 3" class="modal-text">
            {{ $t("publicManage.lanset.statusText") }}
          </p>
        </section>
        <section class="deilog-bottom" slot="modal-footer">
          <!-- 取消 -->
          <b-button class="coustom-btn" @click="switchCancel">
            {{ $t("publicManage.lanset.cancel") }}
          </b-button>
          <!-- 启用/停用 -->
          <b-button class="coustom-btn" variant="primary" @click="switchSubmit">
            <!-- {{ $t('publicManage.lanset.ok') }} -->
            {{
      activeRow.status === 0
        ? $t("publicManage.lanset.startUse")
        : $t("publicManage.lanset.pause")
            }}
          </b-button>
        </section>
      </b-modal>
    </b-card>
  </div>
</template>


<script>
import commonMixin from "@/mixin/common/commonMixin";
import languageSetAdmin from "./languageSetAdmin.vue";
import serverLanguageService from "./serverLanguageService.vue";
export default {
  name: "languageService",
  components: { languageSetAdmin, serverLanguageService },
  mixins: [commonMixin],
  data() {
    return {
      tabIndex: 0,
      notData: false,
      loading: false,
      isOpen: null,
      isOpenType: [],
      webDataList: [],
      appDataList: [],
      serverList: [],
      adminList: [],
      num: 0,
      fileUrl: null,
      uploadType: null,
      uploadLan: null,
      secoundClick: true,
      altersImg: require("@/assets/images/alerts.png"),
      aa: null,
      bb: null,
      addLanguageFlag: false,
      modalDisabled: false,
      statusFlag: false,
      activeRow: {
        text: "简体中文",
        type: "web",
        status: 0,
      },
      tabType: 6, //服务端 5:管理后台 6
    };
  },
  computed: {
    actionMenus() {
      return this.$store.state.baseData.actionMenus
    },
    showBtn() {
      // return this.actionMenus.languageService.indexOf('languageDiff') > -1 && [1,2].includes(this.roleType);
    },
    fields() {
      return [
        {
          key: "sort",
          label: this.$t("publicManage.lanset.sort"),
          class: "enNum",
        }, // 排序
        {
          key: "langName",
          label: this.$t("publicManage.basenav.language"),
          class: "text-right",
        }, //语言描述
        {
          key: "fileName",
          label: this.$t("publicManage.lanset.fileName"),
          class: "text-right",
        }, //文件名称
        {
          key: "status",
          label: this.$t("publicManage.lanset.status"),
          class: "text-right",
        },
        {
          key: "operation",
          label: this.$t("memoryMatchingList.list.operation"),
          class: "text-right",
        }, //  操作
      ];
    },
    url() {
      return this.$store.state.url.imgUpload;
    },
    addText() {
      let text = "";
      this.isOpenType.forEach((item) => {
        if (this.isOpen === item.value) {
          text = item.text;
        }
      });
      return text;
    },
  },
  mounted() {
    // this.getLang();
    this.$nextTick(() => {
      if (this.$route.query.lanType === "admin") {
        this.tabIndex = 0;
      } else if (this.$route.query.lanType === "server") {
        this.tabIndex = 1;
      }
      this.getDownloadAddress();
    });
  },
  methods: {
    remark() {
      this.$http({
        url: this.$store.state.url.languageManage.languageDiff
      }).then((data) => {
        this.$bus.$emit("alert", { type: data.code.toString() === "0" ? "success" : "error", message: data.msg });
      });
    },
    // tab切换
    handleChangeTab(type) {
      this.tabType = type;
      this.getDownloadAddress(this.tabType);
    },
    // 获取下拉语言列表
    // getLang() {
    //   this.$http({
    //     url: "company_lang_list",
    //   }).then((data) => {
    //     if (data.code.toString() === "0") {
    //       // console.log(JSON.parse(data.data.repository.content.text))
    //       this.isOpenType = [];
    //       data.data.list.map((item) => {
    //         if (item.status === 0) {
    //           this.isOpenType.push({ text: item.text, value: item.value });
    //         }
    //       });
    //       this.isOpen = this.isOpenType[0].value;
    //       // console.log(this.isOpen, "isOpen");
    //     } else {
    //       this.$bus.$emit("alert", { type: "error", message: data.msg });
    //     }
    //   });
    // },
    // 开启语言
    addLan() {
      if (!this.secoundClick) return;
      this.secoundClick = false;
      this.addLanguageFlag = true;
    },
    langSure() {
      this.$http({
        url: "company_lang_add",
        params: {
          lang: this.isOpen,
        },
      }).then((data) => {
        if (data.code.toString() === "0") {
          console.log(data);
          // this.getLang();
          this.getDownloadAddress();
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
        this.secoundClick = true;
        this.addLanguageFlag = false;
      });
    },
    langCancel() {
      this.secoundClick = true;
      this.addLanguageFlag = false;
    },
    // 获取下载地址
    getDownloadAddress() {
      this.loading = true;
      this.$http({
        url: "language/langStatuList",
        params: {
          type: this.tabType, ////服务端 5:管理后台6
        },
      }).then((data) => {
        this.loading = false;
        if (data.code.toString() === "0") {
          let arr1 = [];
          let arr2 = [];

          if (this.tabType === 1) {
            data.data.langStatuList.forEach((item) => {
              if (item.status == 1) {
                arr1.push(item);
              } else {
                arr2.push(item);
              }
            });
            arr1 = arr1.reverse();
            arr1 = arr1.concat(arr2);
            this.webDataList = arr1;
          }

          if (this.tabType === 2) {
            data.data.langStatuList.forEach((item) => {
              if (item.status == 1) {
                arr1.push(item);
              } else {
                arr2.push(item);
              }
            });
            arr1 = arr1.reverse();
            arr1 = arr1.concat(arr2);
            this.appDataList = arr1;
          }

          // if (this.tabType === 3)
          //   this.serverList = data.data.langStatuList.reverse();
        } else {
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },
    // 还原
    // upload(lang,type,address){
    //   let status = type === 'web' ? 1 : 2
    //   this.$http({
    //     url: 'company_lang_cloud_address_update',
    //     params: {
    //       lang: lang,
    //       type: status,
    //       address: address,
    //     }
    //     }).then((data) => {
    //     if (data.code.toString() === '0') {
    //       console.log(data)
    //       // this.getLang()
    //       this.getDownloadAddress()
    //     } else {
    //       this.$bus.$emit('alert', {type: 'error', message: data.msg})
    //     }
    //   })
    // },
    modify(lan, type, address, backupAddress) {
      this.$router.push({
        path: "languageModify",
        query: { lan, type, address, backupAddress },
      });
    },
    // 服务端跳转
    modifyServe(lan, type, address, mtime) {
      this.$router.push({
        path: "languageModify",
        query: { lan, type, address, mtime },
      });
    },
    // 还原
    reset(langKey, type, id) {
      this.$bvModal
        .msgBoxConfirm(this.$t("publicManage.lanset.resetNote"), {
          title: this.$t("common.tip"),
          size: "md",
          buttonSize: "md",
          okTitle: this.$t("publicManage.lanset.ok"),
          cancelTitle: this.$t("publicManage.lanset.cancel"),
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            if (type === "web") type = 1;
            if (type === "app") type = 2;
            const paramsData = {
              langKey,
              type,
              id,
            };
            this.$http({
              // url: "company_lang_cloud_address_update",
              url: "language/langFileReduce",
              params: paramsData,
            }).then(({ code, data, msg }) => {
              if (code.toString() === "0") {
                // this.getData();
                this.getDownloadAddress();
                this.$bus.$emit("alert", { type: "success", message: msg }); // '操作成功'
              } else {
                this.$bus.$emit("alert", { type: "error", message: msg });
              }
            });
          }
        })
        .catch((err) => { });
    },
    handleSwitch(row, type) {
      this.statusFlag = true;
      this.activeRow = row;
      this.activeType = type;
    },
    switchCancel() {
      this.statusFlag = false;
    },
    // 停用启用
    switchSubmit() {
      const { langKey, status } = this.activeRow;
      this.$http({
        // url: "onoff",
        url: "language/updateStatus",
        params: {
          langKey: langKey,
          status: status === 0 ? 1 : 0,
          type: this.activeType,
        },
      }).then((data) => {
        if (data.code.toString() === "0") {
          this.getDownloadAddress();
          this.statusFlag = false;
          this.$bus.$emit("alert", { type: "success", message: data.msg });
        } else {
          this.statusFlag = false;
          this.$bus.$emit("alert", { type: "error", message: data.msg });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.basenav {
  .header {
    font-size: 15px;
  }

  .nav-tabs li {
    margin-right: 10px;
  }

  .nav-tabs .nav-link.active {
    cursor: default;
  }
}

.lanSet {
  position: relative;

  .card {
    border-radius: 8px !important;
  }

  .lanList {
    width: 200px;
    float: left;
    margin-right: 40px;
  }

  button {
    margin-right: 10px;
  }

  .input-hide {
    display: none;
  }

  .note {
    margin-top: 15px;
    color: var(--theme-color-red);

    img {
      height: 15px;
      width: 15px;
      margin-right: 5px;
    }
  }
}

.modal-titles {
  text-align: center;
  margin-bottom: 10px;
  font-weight: 600;
}

.red {
  color: var(--theme-color-red);
}

.green {
  color: var(--theme-color-green);
}

.update_btn {
  position: absolute;
  z-index: 1;
  top: 36px;
  right: 40px;
}
</style>
